import styles from './BasicTheme.module.scss';
import CVHeader from 'Components/BasicTheme/CVHeader/CVHeader';
import Experience from 'Components/BasicTheme/ExperienceForm/Experience';
import Education from 'Components/BasicTheme/EducationForm/Education';
import PersonalInformation from 'Components/BasicTheme/PersonalInformation/PersonalInformation';
import { useEffect, useRef } from 'react';

const BasicTheme = ({
    cvBuilderForm,
    handleKeyDown,
    onInputChangedHandler,
    onAddExperience,
    onDeleteExperienceHandler,
    onExperienceChangeHandler,
    onAddEducation,
    onDeleteEducationHandler,
    onEducationChangeHandler,
    onUploadUserProfileImage
}) => {
    const profileImageRef = useRef(null);

    useEffect(() => {
        const { current } = profileImageRef;
        const { profileImageSrc } = cvBuilderForm;

        if (current && profileImageSrc && current.src !== profileImageSrc) {
            current.src = profileImageSrc;
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [profileImageRef.current, cvBuilderForm]);

    return (
        <div className={`col ${styles.CVBuilderForm}`} autoComplete="off">
            <div className={`row justify-content-between`}>
                {/* Left CV Section */}
                <div className={`col-7 p-0 mb-5`}>
                    <CVHeader
                        onInputChangedHandler={onInputChangedHandler}
                        cvFormData={cvBuilderForm}
                    />
                </div>

                {/* Right CV Section */}
                <div className={`col-4 mb-5`}>
                    <div className={`${styles.UserProfileImageContainer}`}>
                        <div
                            className={`${styles.UserProfileImageUploader}`}
                            htmlFor="upload-profile-image">
                            <label
                                className={`d-flex justify-content-center align-items-center h-100 user-select-none`}>
                                <img
                                    src={``}
                                    alt=""
                                    ref={profileImageRef}
                                    style={{
                                        height: cvBuilderForm.profileImageSrc
                                            ? '100%'
                                            : 0
                                    }}
                                    className={`${styles.UserProfileImage}`}
                                />
                                <input
                                    id="upload-profile-image"
                                    type="file"
                                    className="d-none"
                                    accept="image/*"
                                    onChange={(event) =>
                                        onUploadUserProfileImage(
                                            event,
                                            profileImageRef
                                        )
                                    }
                                />
                                {cvBuilderForm.profileImageSrc
                                    ? null
                                    : 'Upload Image'}
                            </label>
                        </div>
                    </div>
                </div>

                <div className={`col-7 p-0`}>
                    <legend
                        className={`form-group-legend ${styles.CVSectionTitleHeader}`}>
                        Experience
                    </legend>
                    <div>
                        <Experience
                            experienceList={cvBuilderForm.experience}
                            onExperienceChangeHandler={
                                onExperienceChangeHandler
                            }
                            handleKeyDown={handleKeyDown}
                            onDeleteExperienceHandler={
                                onDeleteExperienceHandler
                            }
                            cvFormData={cvBuilderForm}
                        />

                        <div>
                            <button
                                onClick={() => onAddExperience()}
                                className={`${styles.AddListItemButton} btn btn-outline-success col`}>
                                Add position
                            </button>
                        </div>
                    </div>

                    <legend
                        className={`form-group-legend mt-5 ${styles.CVSectionTitleHeader}`}>
                        Education
                    </legend>

                    <div>
                        <Education
                            educationList={cvBuilderForm.education}
                            onEducationChangeHandler={onEducationChangeHandler}
                            onDeleteEducationHandler={onDeleteEducationHandler}
                            cvFormData={cvBuilderForm}
                        />

                        <div>
                            <button
                                onClick={() => onAddEducation()}
                                className={`${styles.AddListItemButton} btn btn-outline-success col`}>
                                Add education
                            </button>
                        </div>
                    </div>
                </div>

                <div className={`col-4`}>
                    <PersonalInformation
                        onInputChangedHandler={onInputChangedHandler}
                        cvFormData={cvBuilderForm}
                    />
                </div>
            </div>
        </div>
    );
};

export default BasicTheme;
